const mandatoryReviewKey = 'mandatory_review_helper';

export const getCurrentMandatoryReviewFilter = () => {
  return sessionStorage.getItem(mandatoryReviewKey);
};

export const setCurrentMandatoryReviewFilter = (name: string) => {
  return sessionStorage.setItem(mandatoryReviewKey, name);
};
